import React from "react";
import { ListResponse } from "src/types";

import { fetchAccounts, FetchAccountsPayload } from "@admin/api/account";
import { showErrorToast } from "@shared/toasts/Toasts";

export const useFetchAccounts = (payload?: FetchAccountsPayload) => {
    const [data, setData] = React.useState<API.Account[]>([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const [count, setCount] = React.useState(0);

    const onSuccess = (response: ListResponse<API.Account>) => {
        setData(response.list);
        setCount(response.count);
    };
    const onError = (error: Error) => {
        showErrorToast(error.message);
    };

    React.useEffect(() => {
        setIsLoading(true);
        void fetchAccounts(payload)
            .then(onSuccess)
            .catch(onError)
            .finally(() => setIsLoading(false));
    }, [payload]);

    return { data, isLoading, count, setData };
};
